import React, { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from "@mui/material/Button";
import { IconButton } from '@mui/material';
import { formatDurationHourMinuteSecond } from '../../api/utils/strings';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { Tooltip, withStyles } from '@material-ui/core';

export default function DialogResume(props) {

  const { elements_requested, elements_response } = props;
  const [ userInfoGeneral, setUserInfoGeneral ] = useState({
      'num_hits': 0,  
      'accuracy': 0,
      'counter_repeats': 0,
      'duration':  0
    });
  const [ modelInfoGeneral, setModelInfoGeneral ] = useState({
      'num_hits': 0,  
      'accuracy': 0,
    });

  useEffect(() => {
    // console.log("elements_requested", elements_requested)
    // console.log("elements_response", elements_response)

    let userInfoGeneralUpdated = {}
    userInfoGeneralUpdated['num_hits'] = elements_response['hits'].filter((item) => item === 1).length;
    userInfoGeneralUpdated['accuracy'] = (userInfoGeneralUpdated['num_hits'] / elements_response['hits'].length) * 100;

    let rep_sum = 0;
    elements_response['arr_counter_repeats'].forEach(rep_idx => {
      rep_sum += rep_idx;
    });
    const rep_average = rep_sum / elements_response['arr_counter_repeats'].length;

    userInfoGeneralUpdated['counter_repeats'] = rep_average
    userInfoGeneralUpdated['duration'] = elements_response['duration']
    // console.log("infoGeneralUpdated", userInfoGeneralUpdated)

    setUserInfoGeneral(userInfoGeneralUpdated)

    let modelInfoGeneralUpdated = {}
    modelInfoGeneralUpdated['num_hits']  = elements_requested.filter(item => item.model.top === 1).length;
    modelInfoGeneralUpdated['accuracy'] = (modelInfoGeneralUpdated['num_hits'] / elements_response['hits'].length) * 100;

    setModelInfoGeneral(modelInfoGeneralUpdated)

  }, [elements_requested, elements_response]);

  // useEffect(() => {
  //   console.log("userInfoGeneral", userInfoGeneral)
  // }, [userInfoGeneral]);

  // useEffect(() => {
  //   console.log("modelInfoGeneral", modelInfoGeneral)
  // }, [modelInfoGeneral]);

  return (
    <>
      <div className="sig_SignModal_VideoContainer sig_VersusMachine_Resume">

      <TableContainer component={Paper}>
      <Table className="custom-table" aria-label="customized table">
      <TableHead>
          <TableRow>
            <TableCell className="table-header" colSpan={3} align="center"> RESUMEN </TableCell>
          </TableRow>
            <TableRow>
              <TableCell className="table-header2" align="center">  </TableCell>
              <TableCell className="table-header2" align="center"> Usuario </TableCell>              
              <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="bottom"
                    arrow
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p>El modelo actual está entrenado para detectar 108 signos.</p>
                        <p>En esta sección estamos utilizando 188 signos diferentes.</p>
                        <p>Es decir, la máquina es capaz de reconocer el 57.45% de los signos.</p>
                        <p>Para seguir aprendiendo, nuestro reconocedor necesita ver muchos vídeos que contengan el signo a reconocer.</p>
                        <p><strong>¡Colabora con grabaciones para seguir enseñando LSE a la máquina!</strong></p>
                      </div>
                    }>
                <TableCell className="table-header2" align="center"> Máquina </TableCell>
              </Tooltip>
            </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className="table-cell"> Nº de aciertos </TableCell>
            <TableCell className="table-cell" align="center"> {userInfoGeneral['num_hits']} </TableCell>
            <TableCell className="table-cell" align="center"> {modelInfoGeneral['num_hits']} </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="table-cell"> % aciertos </TableCell>
            <TableCell className="table-cell" align="center"> {userInfoGeneral['accuracy']}% </TableCell>
            <TableCell className="table-cell" align="center"> {modelInfoGeneral['accuracy']}% </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="table-cell"> Repeticiones </TableCell>
            <TableCell className="table-cell" align="center"> {userInfoGeneral['counter_repeats']}</TableCell>

          </TableRow>
          <TableRow>
            <TableCell className="table-cell"> Tiempo requerido </TableCell>
            <TableCell className="table-cell" align="center"> {formatDurationHourMinuteSecond(userInfoGeneral['duration'])}</TableCell>
            
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

    <br />
            
      <TableContainer component={Paper}>
      <Table className="custom-table" aria-label="customized table">
        <TableHead >
          <TableRow>
            <TableCell className="table-header" colSpan={3} align="center"> REGISTROS DEL USUARIO </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="table-header2" align="center"> Entrada </TableCell>
            <TableCell className="table-header2" align="center"> Respuesta </TableCell>
            <TableCell className="table-header2" align="center"> Acierto / Fallo </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        {elements_response.arr_lemmas_request.map(( item, index) => {
          return (
              <TableRow key={index}>
                <TableCell className="table-cell"  align="center">{elements_response['arr_lemmas_request'][index]}</TableCell>
                <TableCell className="table-cell" align="center"> {elements_response['arr_lemmas_annotated'][index]} </TableCell>
                <TableCell className="table-cell" align="center">  <Button className="buttonIcon-cell">  {elements_response['hits'][index] ? <CheckCircleOutlineIcon color='success'/> : <HighlightOffIcon color='error'/>  }  </Button>  </TableCell>
              </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </TableContainer>

      </div>
    </>
  );
}